module.exports = __webpack_public_path__ + "Lato-Thin.0faa1074c17a74a7f5e3.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Thin.woff2
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Thin.woff2
// module chunks = styles